import React from "react"
import CommonTypo from "../../../components/CommonTypo"
import { Box } from "@mui/material"
import NewButton from "../../../components/NewButton"

const Step1 = ({ setNextStep, setPreviousStep }) => {
    return <>
        <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36}>Hey! I’m Frost!</CommonTypo>
        <CommonTypo size={16} fontWeight={400} color="var(--color-text-secondary)" lineHeight={22}>Your personal research buddy and TNT's chief ice cream quality inspector... I mean, behavioral pattern specialist. Let’s complete onboarding together?</CommonTypo>
        <Box sx={{
            height: '42px',
            display: "flex",
            alignItems: "center",
            gap: "8px",
            borderRadius: "12px",
            border: "2px solid var(--color-border)",
            padding: "8px",
        }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 1.5625C8.33122 1.5625 6.69992 2.05735 5.31238 2.98448C3.92484 3.9116 2.84338 5.22936 2.20477 6.77111C1.56616 8.31286 1.39907 10.0094 1.72463 11.6461C2.05019 13.2828 2.85378 14.7862 4.03379 15.9662C5.2138 17.1462 6.71721 17.9498 8.35393 18.2754C9.99064 18.6009 11.6871 18.4338 13.2289 17.7952C14.7706 17.1566 16.0884 16.0752 17.0155 14.6876C17.9427 13.3001 18.4375 11.6688 18.4375 10C18.435 7.763 17.5453 5.61833 15.9635 4.03653C14.3817 2.45473 12.237 1.56498 10 1.5625ZM10 16.5625C8.70206 16.5625 7.43327 16.1776 6.35407 15.4565C5.27488 14.7354 4.43374 13.7105 3.93704 12.5114C3.44034 11.3122 3.31038 9.99272 3.5636 8.71972C3.81682 7.44672 4.44183 6.27739 5.35962 5.35961C6.2774 4.44183 7.44672 3.81681 8.71972 3.5636C9.99272 3.31038 11.3122 3.44034 12.5114 3.93704C13.7105 4.43374 14.7354 5.27487 15.4565 6.35407C16.1776 7.43327 16.5625 8.70206 16.5625 10C16.5606 11.7399 15.8686 13.408 14.6383 14.6383C13.408 15.8686 11.7399 16.5606 10 16.5625ZM15.3125 10C15.3125 10.2486 15.2137 10.4871 15.0379 10.6629C14.8621 10.8387 14.6236 10.9375 14.375 10.9375H10C9.75136 10.9375 9.51291 10.8387 9.33709 10.6629C9.16127 10.4871 9.0625 10.2486 9.0625 10V5.625C9.0625 5.37636 9.16127 5.1379 9.33709 4.96209C9.51291 4.78627 9.75136 4.6875 10 4.6875C10.2486 4.6875 10.4871 4.78627 10.6629 4.96209C10.8387 5.1379 10.9375 5.37636 10.9375 5.625V9.0625H14.375C14.6236 9.0625 14.8621 9.16127 15.0379 9.33709C15.2137 9.5129 15.3125 9.75136 15.3125 10Z" fill="#292B2A" />
            </svg>

            <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={22}>It only takes 5 minutes</CommonTypo>
        </Box >
        <NewButton
            variant="contained"
            buttonText={"Let’s do it!"}
            onClick={setNextStep}
            isLoadong={false}
            isDisabled={false}
            padding="16px"
            boxPadding="0px"
            extraSx={{
                height: "40px"
            }}
        />
    </>
}

export default Step1